var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var DataTable = require('../../lib/datatable.js');
var Columnator = require('../../lib/columnator.js');
var Vue = require('vue');
var ExportActionDropdown = require('../../lib/components/Exports/ExportActionDropdown.vue')
  .default;
const SavedViewsShortcutsBar = require('./../search/components/SavedViewsShortcutsBar')
  .default;
const SavedViewsList = require('./../search/components/SavedViewsList').default;
const SaveViewForm = require('./../search/components/SaveViewForm').default;
const store = require('@/lib/store').default;

module.exports = function() {
  var datatable = new DataTable();

  datatable.setup('.datatable');

  let savedViewsList, saveViewForm;

  $('.filtertron-tray').filtertronTray({
    onOpen: function() {
      datatable.refresh();

      if (!savedViewsList && !saveViewForm) {
        saveViewForm = new Vue({
          el: '.save-view-form',
          components: {
            SaveViewForm
          },
          store
        });

        savedViewsList = new Vue({
          el: '.saved-searches',
          components: {
            SavedViewsList
          },
          store
        });

        $(document).one('pjax:end', () => {
          saveViewForm.$destroy();
          savedViewsList.$destroy();
        });
      }
    },
    onClose: function() {
      datatable.refresh();
    }
  });

  new Vue({
    el: '#export-action',
    components: {
      'export-action-dropdown': ExportActionDropdown
    }
  });

  var marker = new Marker('orders');

  new Deletism(marker);
  new Undeletism(marker);

  new Columnator();

  const savedViewsShortcutsBar = document.getElementById(
    'saved-views-shortcuts-bar'
  );
  if (savedViewsShortcutsBar) {
    new Vue({
      el: savedViewsShortcutsBar,
      components: {
        'saved-views-shortcuts-bar': SavedViewsShortcutsBar
      },
      store
    });
  }
};
